type Props = { message: string; onRetry?: () => void }

export function ErrorNotice({ message, onRetry }: Props) {
  return (
    <div className="card" role="alert">
      <p className="status-err">Something went wrong: {message}</p>
      {onRetry && (
        <button type="button" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  )
}
